import Integration from './integration';
import Entity from './entity';

class Wrap {
  static entity = (entityData) => new Entity(entityData);
  static integration = (integrationData) => new Integration(integrationData);
}

export default Wrap;
